import PermissionDeniedCard from './PermissionDeniedCard'

export default PermissionDeniedCard
